/**
 * Vertical list wrapper mapping chats to `ChatPreviewCard` with an empty state.
 *
 * Where: `LeadOverview` accordion sections.
 * Uses: `ChatPreviewCard` only.
 * Behavior: renders empty copy when `chats` is empty.
 */
import React from 'react';
import {
  Typography,
  Stack,
} from '@mui/material';
import { ChatPreviewCard } from './ChatPreviewCard';

interface ChatsListProps {
  chats: any[];
  onOpenChat: (chatUuid: string) => void;
  onOpenStream?: (streamUuid: string) => void;
}

export const ChatsList: React.FC<ChatsListProps> = ({
  chats,
  onOpenChat,
  onOpenStream,
}) => {
  return (
    <Stack spacing={1}>
      {chats.map((c: any) => (
        <ChatPreviewCard key={c.key || c.uuid} chat={c} onOpenChat={onOpenChat} onOpenStream={onOpenStream} />
      ))}
      {chats.length === 0 && (
        <Typography variant="body2" color="text.secondary">No chats yet</Typography>
      )}
    </Stack>
  );
};

